/** A chat may be marked read only when the user can actually see it.
 * Background tabs kept polling an open Bumblebee chat and silently marked
 * every new message read, so unread badges showed 1 (or 0) instead of the
 * real count. */
export function shouldMarkChatRead(): boolean {
	return document.visibilityState === "visible";
}
